(() => {
  if (customElements.get('ss-buy-bundle')) return;

  class SsBuyBundle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-ss-bundle-submit]');
      this.status = this.querySelector('[data-ss-bundle-status]');
      this.cartLink = this.querySelector('[data-ss-bundle-cart]');
      this.button?.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
    }

    say(key) {
      if (this.status) this.status.textContent = this.dataset[key] || '';
    }

    handleClick = async () => {
      if (this.pending || !this.button) return;
      const component = document.querySelector(`product-form-component[data-product-id="${this.dataset.productId}"]`);
      const form = component?.querySelector('form[data-type="add-to-cart-form"]');
      const unavailable = Array.from(component?.querySelectorAll('add-to-cart-component') || [])
        .some(container => container.refs?.addToCartButton?.disabled);
      const variant = form?.querySelector('input[name="id"]');
      if (!form || !variant?.value || variant.disabled || unavailable) {
        this.say('choose');
        return;
      }
      if (!form.reportValidity()) return;
      const quantityCheck = component.refs?.quantitySelector?.canAddToCart?.();
      if (quantityCheck && !quantityCheck.canAdd) {
        this.say('quantity');
        return;
      }

      const data = new FormData(form);
      const quantity = Number(data.get('quantity') || component.dataset.quantityDefault || 1);
      if (!Number.isSafeInteger(quantity) || quantity < 1) {
        this.say('quantity');
        return;
      }
      const main = { id: variant.value, quantity };
      const plan = data.get('selling_plan');
      if (plan) main.selling_plan = String(plan);
      const properties = Object.create(null);
      for (const [key, value] of data.entries()) {
        const match = /^properties\[(.+)\]$/.exec(key);
        if (!match) continue;
        if (typeof value !== 'string') {
          if (value.size) {
            this.say('native');
            return;
          }
          continue;
        }
        properties[match[1]] = value;
      }
      if (Object.keys(properties).length) main.properties = properties;

      const items = [main];
      const seen = new Set([variant.value]);
      this.querySelectorAll('[data-ss-bundle-variant]:checked').forEach(input => {
        if (input.value && !input.disabled && !seen.has(input.value)) {
          items.push({ id: input.value, quantity: 1 });
          seen.add(input.value);
        }
      });

      const root = window.Shopify?.routes?.root || '/';
      this.pending = true;
      this.button.disabled = true;
      this.setAttribute('aria-busy', 'true');
      if (this.cartLink) this.cartLink.hidden = true;
      this.say('loading');
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('cart_add_failed');
        this.say('success');
        window.location.assign(`${root}cart`);
      } catch {
        this.say('error');
        if (this.cartLink) this.cartLink.hidden = false;
        this.status?.focus();
      } finally {
        this.pending = false;
        this.button.disabled = false;
        this.removeAttribute('aria-busy');
      }
    };
  }

  customElements.define('ss-buy-bundle', SsBuyBundle);
})();
